import { useTranslation } from 'react-i18next';

import ListFilterToolbar from 'src/common/components/list-filters/ListFilterToolbar';
import { EUserOrderBy } from 'src/common/constants/userSortKeys';
import { EOrder } from 'src/interfaces/Order';
import { EView } from 'src/interfaces/View';
import UsersFilterPopoverContent, {
  usersFilterIsActive,
} from 'src/pages/Dashboard/Users/forms/UsersFilterPopover';

interface Props {
  query: string;
  onQuery: (q: string) => void;
  roleFilter: string | null;
  onRoleFilter: (roleId: string | null) => void;
  order: EOrder;
  orderByKey: EUserOrderBy;
  setOrder: (o: EOrder) => void;
  setOrderByKey: (k: EUserOrderBy) => void;
  view: EView;
  onSetView: (v: EView) => void;
}

const UsersFilterForm = ({
  query,
  onQuery,
  roleFilter,
  onRoleFilter,
  order,
  orderByKey,
  setOrder,
  setOrderByKey,
  view,
  onSetView,
}: Props) => {
  const { t } = useTranslation();

  const sortOptions = [
    { label: t('form.name'), value: EUserOrderBy.name },
    { label: t('form.email'), value: EUserOrderBy.email },
    { label: t('users.role'), value: EUserOrderBy.role },
  ];

  return (
    <ListFilterToolbar
      popupId="usersFilters"
      searchQuery={query}
      onSearchChange={onQuery}
      searchPlaceholder={t('system.listFilters.searchPlaceholder')}
      hasActiveFilters={usersFilterIsActive(roleFilter)}
      filterPopoverContent={
        <UsersFilterPopoverContent roleFilter={roleFilter} onRoleFilter={onRoleFilter} />
      }
      order={order}
      orderByKey={orderByKey}
      setOrder={setOrder}
      setOrderByKey={v => setOrderByKey(v as EUserOrderBy)}
      sortOptions={sortOptions}
      view={view}
      onSetView={onSetView}
    />
  );
};

export default UsersFilterForm;
